import React from 'react';
import { useSelector } from 'react-redux';

import { HeaderSection } from '../../../components/HeaderSection/HeaderSection';
import { breadcrumbsSelector, selectH1 } from '../../../selectors/commonSelectors';
import { Breadcrumbs } from '../../../serp/components/Breadcrumbs';
import { SummaryContainer } from '../../../serp/containers/SummaryContainer';
import { MapBannerContainer } from '../../MapBannerContainer';

/* istanbul ignore next */
export function FlatSaleExpHeaderSectionContainer() {
  const breadcrumbs = useSelector(breadcrumbsSelector);
  const h1 = useSelector(selectH1);

  return (
    <HeaderSection
      breadcrumbs={<Breadcrumbs breadcrumbs={breadcrumbs} h1={h1} />}
      summary={<SummaryContainer />}
      mapBanner={<MapBannerContainer />}
    />
  );
}
